import React from 'react'
import styled from 'styled-components'
import product_list_wrapperStyles from './product_list_wrapper.styles'

const apAtomName = {ap_atom_name: 'apProductListWrapperAtom'}

const StyledWrapper = styled(props => <ul {...props} />)`
  ${product_list_wrapperStyles}
`

const ProductListWrapperAtom: React.FC = function (props) {
  return <StyledWrapper {...apAtomName} {...props} />
}

export default ProductListWrapperAtom
